import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { networksSelector } from 'redux/selectors';

export const usePublicAgent = () => {
  const { networks } = useSelector(networksSelector);

  // Get collectionId and agent_id from query params
  const urlParams = new URLSearchParams(window.location.search);
  const collectionId = urlParams.get('collection_id');
  const currentAgentId = urlParams.get('agent_id');

  // Find network by ID or slug from the store
  const network = useMemo(() => {
    if (!networks || !collectionId) return null;

    // First try to find by ID (direct key lookup)
    if (networks[collectionId]) {
      return networks[collectionId];
    }

    // Then try to find by slug
    return Object.values(networks).find((n) => n.slug === collectionId) || null;
  }, [networks, collectionId]);

  return {
    isLoading: false,
    error: null,
    agentId: currentAgentId,
    collectionId: network?.id || collectionId,
    network,
  };
};
